var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFirstCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 23.8334L18.3334 18.0015C18.3338 18.2316 18.4287 18.4616 18.618 18.6272L25.2847 24.4606C25.8235 24.932 26.6667 24.5494 26.6667 23.8334L26.6667 12.1667C26.6667 11.4508 25.8235 11.0681 25.2847 11.5396L18.618 17.3729C18.4287 17.5386 18.3338 17.7686 18.3334 17.9987L18.3334 12.1667C18.3334 11.4508 17.4901 11.0681 16.9513 11.5396L10.2847 17.3729C9.90522 17.7049 9.90522 18.2952 10.2847 18.6272L16.9513 24.4606C17.4901 24.932 18.3334 24.5494 18.3334 23.8334ZM20.4322 18L25.0001 21.9969L25.0001 14.0032L20.4322 18ZM16.6667 14.0032L12.0989 18L16.6667 21.9969L16.6667 14.0032Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 11.3334H8.33325L8.33325 24.6667H9.99992L9.99992 11.3334Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirstCircle);
export default __webpack_public_path__ + "static/media/icon_first_circle.0ec2ceae.svg";
export { ForwardRef as ReactComponent };